import React, { useEffect } from "react";
import type { ModalViewType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import type { InsuranceCalculatorModalType } from "../../../../../utils/modalConstants";
import useAphInsuranceCalculatorButton from "../../../../../hooks/useAphInsuranceCalculatorButton";
import SidePanel from "../../../../../../shared-components/css-modules/lexus/organisms/SidePanel";
import styles from "../../../../../../shared-components/css-modules/lexus/organisms/SidePanel.module.scss";
import CalculatorError from "./CalculatorError";

const InsuranceCalculatorModal = (props: ModalViewType<InsuranceCalculatorModalType>): JSX.Element => {
    const { show, modalSettings } = props;
    const { injectionError } = modalSettings;

    const { showCalculator, isT1InjectionReady, onClose, containerId } = useAphInsuranceCalculatorButton();

    useEffect(() => {
        if (isT1InjectionReady) showCalculator();

        // UseEffect only needs to rerun when the isT1InjectionReady changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isT1InjectionReady]);

    return (
        <SidePanel open={show} onRequestClose={onClose} variant="fullscreen">
            {injectionError ? (
                <CalculatorError containerId={containerId} />
            ) : (
                <div className={`or-modal-content tor-modal-content ${styles["injection-content"]}`}>
                    <div id={containerId} />
                </div>
            )}
        </SidePanel>
    );
};

export default InsuranceCalculatorModal;
